import loader from "./loader";

// makeLoader returns a function that injects the SDK script for the given taggingHash.
// The factory shape exists because taggingHash is a per-call parameter.
const makeLoader = (taggingHash) =>
    loader(() => {
        const g = document.createElement("script");
        g.async = true;
        g.src = `https://tags.creativecdn.com/${taggingHash}.js`;
        const s = document.getElementsByTagName("script")[0];
        if (s) {
            s.parentNode.insertBefore(g, s);
        } else {
            document.head.appendChild(g);
        }
    });

export default function rtbhouse(taggingHash, ...events) {
    // Single source of dedup
    window.rtbhEvents = window.rtbhEvents || [];
    if (!document.querySelector("script[src*='creativecdn']")) {
        makeLoader(taggingHash)();
    }
    // Send events
    events.forEach((e) => window.rtbhEvents.push(e));
}
